export default function menu() {
  jQuery(function () {
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    if (isIE11 == false) {
      $('body').removeClass('ie11');
    }
  })
}